import { Button, TableCell } from '@mui/material';
import styled from 'styled-components';

export const ActionsTableCell = styled(TableCell)`
    white-space: nowrap;

    padding: 0.2rem 1rem;
`;

export const StyledActionButton = styled(Button)`
    white-space: nowrap;
`;

export const StyledTableCell = styled(TableCell)`
    padding: 0 1rem;
`;
